import { render } from "./forum.vue?vue&type=template&id=34f1361a&scoped=true"
import script from "./forum.vue?vue&type=script&lang=js"
export * from "./forum.vue?vue&type=script&lang=js"

import "./forum.vue?vue&type=style&index=0&id=34f1361a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34f1361a"

export default script